'use strict';

export default angular
  .module('maestro.services.data.rules', [
    'maestro.services.webcore'
  ])
  .service('RulesService', RulesService)
  .name;

function RulesService(webcore, $q) {

  /**
   * Gets rules for specific location
   * @param locationId
   * @returns {*}
   */
  this.getLocationRules = (locationId) => {
    return $q.when(
      webcore.services.rules.getLocationRules(locationId, false)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Gets rules for specific device
   * @param locationId
   * @param deviceId
   * @param userId
   * @returns {*}
   */
  this.getDeviceRules = (locationId, deviceId, userId) => {
    userId = userId ? userId : null;
    return $q.when(
      webcore.services.rules.getDeviceRules(locationId, deviceId, userId, false)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Creates device default rules.
   * @param {string} deviceId
   * @param {number} userId
   */
  this.createDeviceDefaultRules = (deviceId, userId) => {
    return $q.when(
      webcore.services.rules.createDeviceDefaultRules(deviceId, userId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Creates user's default rules for devices
   * @param userId
   */
  this.createUserDevicesDefaultRules = (userId) => {
    return $q.when(
      webcore.services.rules.createUserDevicesDefaultRules(userId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Deletes specified rule. UserId may be specified to perform the operaton by admin user, otherwise the ruleId of the
   * currently logged in user will be tried to be deleted.
   * @param ruleId
   * @param userId
   * @returns {*}
   */
  this.deleteRule = (ruleId, userId) => {
    return $q.when(
      webcore.services.rules.deleteRule(ruleId, userId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Update rule.
   * @param {number} ruleId Rule ID to update.
   * @param {*} updateRuleModel Rule data to update the entity with.
   * @param params Request parameters.
   * @param {number} params.locationId Location ID.
   * @returns {Promise}
   */
  this.updateRule = (ruleId, updateRuleModel, params) => {
    return $q.when(
      webcore.services.rules.updateRule(ruleId, updateRuleModel, params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Allows to get specific rule.
   * @param {number} ruleId Rule ID. Rule ID to obtain.
   * @param params Request parameters.
   * @param {number} params.locationId Location ID.
   * @param {boolean} [params.details] Details. Optional parameter.
   *  'true' - Return details for this rule, including all the triggers, states, and actions that compose the rule.
   *  'false' - Only return the high level information about the rule, including the id, description text, on/off status,
   *   whether the rule is a default rule, and whether the rule is hidden and not editable, default.
   * @returns {Promise}
   */
  this.getRule = (ruleId, params) => {
    return $q.when(
      webcore.services.rules.getRule(ruleId, params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Gets rule phrases.
   * @param params Request parameters
   * @param {number} params.locationId Location ID.
   * @param {number} [params.version] Rules implementation version. Optional parameter.
   * @returns {Promise}
   */
  this.getRulePhrases = (params) => {
    return $q.when(
      webcore.services.rules.getRulePhrases(params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

}
